/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from '../../../../services'

 
export const getAllOrgApplicationDevices = createAsyncThunk('org/getAllOrgApplicationDevices', async (_, { rejectWithValue }) => {
    try { 
        const data = await api.orgApplicationDevices 
        .getAllOrgApplicationDevices()
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getAllOrgsAppsDevicesByOrgID = createAsyncThunk('org/getAllOrgsAppsDevicesByOrgID', async (orgid, { rejectWithValue }) => {
    try { 
        const data = await api.orgApplicationDevices
        .getAllOrgsAppsDevicesByOrgID(orgid)
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getOrgAppDeviceHistory = createAsyncThunk('org/getOrgAppDeviceHistory', async (params, { rejectWithValue }) => {
    try { 
        const data = await api.orgApplicationDevices
        .getOrgAppDeviceHistory(params)
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
